__turbopack_context__.v({
  "horizontal": "AspectRatio-module-scss-module__qTqGvG__horizontal",
  "square": "AspectRatio-module-scss-module__qTqGvG__square",
  "vertical": "AspectRatio-module-scss-module__qTqGvG__vertical",
});
